const getDeepObjectValue = (theObject: Record<string, unknown>, path: string[]) => {
  if (path.length === 0) return null

  let result: unknown = { ...theObject }

  for (let i = 0; i < path.length; i++) {
    const key = path[i]
    if (typeof result === 'object' && Object.prototype.hasOwnProperty.call(result, key)) {
      // @ts-ignore
      result = result[key]
    } else {
      result = null
      break
    }
  }

  return result
}

export default getDeepObjectValue
